const RoundDecimal = (value) => {
    var result = Math.round(value * 100) / 100
    return (result);
};
export default RoundDecimal;